export const COLUMN_TYPE = {
  INDEX: 'index'
};
export const ODATA = {
  METADATA: '$metadata',
  FILTER: '$filter',
  AND: 'and',
  SKIP: '$skip',
  TOP: '$top',
  FILTERS: '?$filter=',
  SEPARATOR: '/',
  SKIP_EQ: '$skip=',
  TOP_EQ: '$top=',
  ORDER: '$orderby=',
  INLINECOUNT_EQ: '$inlinecount=',
  WITH: '&',
  ERROR: 'E',
  SUCESS: 'S',
  WARNING: 'W',
  EXPAND: '?$expand='
};
export const OPT = {
  CREATE: 'C',
  UPDATE: 'U',
  VIEW: 'V',
  DELETE: 'D',
  SUMBIT: 'S',
  DISABLE: 'X',
  EDIT: 'E'
};
// 土地出让金地上、地下
export const LAND_TRANSFER_FEES = {
  UP: 'Y01.047.003',
  DOWN: 'Y01.047.009',
  AUCTION_DEPOSIT: 'Y01.030.016'
};
// K2接口
export const K2ODATA = {
  SERVICE_ID: 'ZFBC_K2_APPR_SRV',
  ENTITY_NODE: 'K2RretunInfoSet',
  ERROR_SERVICE_ID: 'ZFBC_K2_MESSAGE_SRV',
  ERROR_ENTITY_NODE: 'MessageSet'
};
export const MODULE = {
  COMMON: 'common'
};
// sd 公用
export const SD = {
  COMMON: 'ZFSD_COMMON_DOMAIN_SRV',
  DOMAINLIST: 'DomainListSet',
  PROFITCENTER: 'ProfitCenterSet',
  fileBusinessDomain: 'Kr6MdJviNPnDN6bPpYrp',
  fileProject: 'project100001',
  fileType: '-qpJR8Txk5bNWZo50TDB',
  fileSourceSystem: 'ysWmeXRODZPrFgkAMf0Z',
  SrvType: 'SD',
  ycgkServiceId: 'ZFFI_QZGKJY_SRV',
  ycgkEntity: 'ZdisplaySet',
  fileCode: 'PT00278'
};
// sd 公用
export const IM = {
  COMMON: 'ZFSD_COMMON_DOMAIN_SRV',
  DOMAINLIST: 'DomainListSet',
  PROFITCENTER: 'ProfitCenterSet',
  fileBusinessDomain: 'Kr6MdJviNPnDN6bPpYrp',
  fileProject: 'project100001',
  fileType: '-qpJR8Txk5bNWZo50TDB',
  fileSourceSystem: 'ysWmeXRODZPrFgkAMf0Z',
  SrvType: 'IM',
  ycgkServiceId: 'ZFFI_QZGKJY_SRV',
  ycgkEntity: 'ZdisplaySet'
};
// BPM接口
export const BPM_SERVICE_ID = 'ZFBC_BPM_LINK_SRV';
export const BPM_ENTITY_SET = 'BpmLinkSet';
// K2审批状态
export const K2_STATUS = {
  WTJ: '10',
  SPZ: '20',
  SPZF: '30',
  SPBHBCZ: '40',
  SPBHCZ: '41',
  SPTG: '50' // 审批通过
};